<template>
  <div class="login-card__change-email steps-primary-6">
    <div>
      <div class="login-card__big-icon login-card__big-icon--verification">
        <img src="../../../images/registration/email-verify.png" alt="Mailbox icon">
      </div>

      <div class="login-card__title-box">
        <h2 class="login-card__title">
          {{ trans.get('auth.card.verification.email.header') }}
        </h2>
        <p class="login-card__verification-desc">
          <span v-html='trans.get("auth.card.verification.email.message", { email: form.email })'></span>
          <strong> {{ trans.get('auth.card.verification.email.message_spam') }}</strong>
        </p>
      </div>

      <div v-if="mailWebLink" class="login-card__buttons-box">
        <a :href="mailWebLink" class="button button--primary button__auth button__auth--auto-w button-direct" target="_blank">
          {{ trans.get('auth.card.verification.email.mail_web', { url: mailWebDomain }) }}
        </a>
      </div>

      <div>
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)">
            <div class="form-group">
              <validation-provider name="email" rules="required" v-slot="{ errors }" mode="eager">
                <div class="change-email-input">
                  <label for="email">{{ trans.get('edit.email_label') }}</label>
                  <input type="email" id="email" class="input-text__underline" v-model="form.email" placeholder="E-mail">
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>

            <button type="submit" class="button__auth">{{ trans.get('auth.card.change_email.form_button') }}</button>
          </form>
        </validation-observer>
      </div>

      <button type="button" class="button button__link button--back" @click="goBack">
        <i class="demo-icon icon-left"> </i>
        <span>{{ trans.get('auth.card.buttons.back') }} </span>
      </button>
    </div>
  </div>
</template>
<script>
import AuthGoBackMixin from '../../../../js/front/components/Auth/AuthGoBackMixin';
import EmailDomainMixin from './EmailDomainMixin';

export default {
  props: ['swapComponent', 'form'],
  mixins: [AuthGoBackMixin, EmailDomainMixin],
  data: () => ({}),
  computed: {},
  methods: {
    onSubmit() {
      const self = this;
      axios.post(zRoute('register.email.update'), { email: this.form.email, })
        .then(function (response) {
          if (response.data.status === 'success') {
            // if (window.globals.settings_verification_required) {
            self.swapComponent('auth-verification-email-card');
          }
        }, function (error) {
          if (error.response.status === 422) {
            if (!('email' in error.response.data.errors)) {
              self.$refs.form.setErrors({ 'email': error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] });
            } else {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        });
    },
    goBack() {
      this.swapComponent('auth-verification-email-card');
    },
  },
  activated() {
  },
};
</script>
<style scoped>

</style>
